import { FC } from 'react';
import { useRecoilState } from 'recoil';
import { InfoRounded } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import { generalSnackBarAtom } from '../../../data-access';
import StyledSnackBar from './StyledSnackBar';

const GeneralSnackBar: FC = () => {
  const { t } = useTranslation();
  const [generalSnackbar, setGeneralSnackbar] = useRecoilState(generalSnackBarAtom);

  const handleClose = () => setGeneralSnackbar(null);

  return (
    <StyledSnackBar
      open={!!generalSnackbar}
      message={generalSnackbar}
      icon={<InfoRounded sx={{ color: '#fff', fontSize: 20 }} />}
      color="#5c6bc0"
      onClose={handleClose}
      autoHideDuration={4000}
      closeAriaLabel={t('data.common.close')}
    />
  );
};

export default GeneralSnackBar;
